import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import { navigateTo } from '../utils/navigation';

var config = process.env;

class RefreshTokenPage extends Component {

	constructor(){
        super();
        const queryParams = new URLSearchParams(window.location.search);
        const state = queryParams.get('state') || 'global:0';
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: Number(localStorage.getItem('role') || 0),
            code: queryParams.get('code'),
            state,
        }
	}

	componentWillMount() {
        this.validateSession();
    }
    
    validateSession = () => {
        var request = {
            method: 'POST',
            headers: { 
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'session/checkSessionAdmin', request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                if (data.data.isValidToken) {
                    if (data.data.role == 2) {
                        window.location.href = config.REACT_APP_REDIRECT_BOX_GAME;
                    } else {
                        this.setState({ checked: true, role: data.data.role });
                        this.createToken();
                    }
                } else {
                    window.location.href = config.REACT_APP_REDIRECT_LOGIN;
                }
            }
        });
    }

    parseOAuthState = () => {
        const [mode = 'global', rawBranchId = '0'] = String(this.state.state || 'global:0').split(':');
        const parsedBranchId = Number(rawBranchId);
        return {
            mode: mode === 'branch' ? 'branch' : 'global',
            branchId: Number.isNaN(parsedBranchId) ? 0 : parsedBranchId,
        };
    }

    createToken = () => {
        const parsedState = this.parseOAuthState();
        var request = {
            method: 'POST',
            headers: { 
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                code: this.state.code,
                mode: parsedState.mode,
                branchId: parsedState.branchId,
            })
        };
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}configuration/settings/mercadolibre/exchange-token`, request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                return;
            }

            navigateTo('/configurations?tab=mercadolibre');
        });
    }
    
	render() {
        if (!this.state.checked) {
            return (<div></div>);
        } else {
            return (  
                <div class="container-fluid">
                    <div class="row">
                        <SidebarComponent itemSelected={8} role={this.state.role}/>
                        <main class="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                            <NavbarComponent role={this.state.role} />
                            <div className="main-content-container container-fluid px-4 mb-4" style={{paddingBottom: '80px'}}></div>
                        </main>
                    </div>
                    
                    <div onClick={() => this.addPurchase()} class="color-switcher-toggle animated pulse infinite" style={{display: (this.state.role == 2) ? 'none' : 'block'}}>
                        <i class="material-icons">add</i>
                    </div>
                </div>
            );
        }
    }
}

export default RefreshTokenPage;
